import React from "react";
import PropTypes from "prop-types";

import { FormGroupTitle, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import { addIUVersionValidator } from "validators/addVersionValidator";

import {
  CREATE_INCREMENTAL_UPGRADE_VERSION,
  READ_INCREMENTAL_UPGRADE_VERSIONS_NAME,
} from "graphqlQueries/incrementalUpgrade";

const AddIncrementalUpgradeVersion = (props) => {
  const initialValues = {
    version: "",
  };

  const fieldsWithPlaceForError = ["version"];

  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_INCREMENTAL_UPGRADE_VERSION}
      refetchQueries={[READ_INCREMENTAL_UPGRADE_VERSIONS_NAME]}
      initialValues={initialValues}
      validationSchema={addIUVersionValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New incremental upgrade version"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Incremental upgrade version information" />
      <FormTextField name="version" label="Version" />
    </DialogFormWithMutation>
  );
};

AddIncrementalUpgradeVersion.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AddIncrementalUpgradeVersion;
